(function() {
  const initCardNav = () => {
    const cardImages = document.querySelectorAll('.card-product-images, .card-product-video');
    
    cardImages.forEach(container => {
      // Avoid duplicate listeners
      if (container.dataset.navInitialized) return;
      container.dataset.navInitialized = 'true';

      const prevBtn = container.querySelector('.card-product-nav--prev');
      const nextBtn = container.querySelector('.card-product-nav--next');

      if (!prevBtn || !nextBtn) return;

      // Event listener for Next Button (right side)
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        container.classList.add('nav-active');
        nextBtn.style.display = 'none';
        prevBtn.style.display = 'flex';
      });

      // Event listener for Prev Button (left side)
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        container.classList.remove('nav-active');
        nextBtn.style.display = 'flex';
        prevBtn.style.display = 'none';
      });
    });
  };

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardNav);
  } else {
    initCardNav();
  }

  // Handle dynamic content (filters, search, etc.)
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
           if (node.nodeType === 1 && (node.classList.contains('card-product') || node.querySelector('.card-product'))) {
             shouldInit = true;
           }
        });
      }
    });
    if (shouldInit) initCardNav();
  });

  // Observe the whole body since grids can be replaced entirely
  observer.observe(document.body, { childList: true, subtree: true });
})();
